var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7369 5.7052C16.1438 6.11217 16.1438 6.77199 15.7369 7.17896L10.9159 12L15.7369 16.821C16.1438 17.228 16.1438 17.8878 15.7369 18.2947C15.3299 18.7017 14.6701 18.7017 14.2631 18.2947L8.70522 12.7369C8.29825 12.3299 8.29825 11.6701 8.70522 11.2631L14.2631 5.7052C14.6701 5.29823 15.3299 5.29823 15.7369 5.7052Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.ec717113b3e2e036cf064778065f2107.svg";
export { ForwardRef as ReactComponent };